import React, { useEffect } from "react";

import HomePageItems from "./cards";
import { pageNotFound, PageTypePath } from "utils/pages";
import Error404 from "../pages/error/Error404";

import RegistrationForm from "../pages/registration/Form";
import RegistrationList from "component/pages/registration/RegistrationList";
import SalesNotesList from "component/pages/salesNote/SalesNotesList";
import LandingNoteList from "component/pages/landingNote/LandingNotesList";
import SalesNoteForm from "component/pages/salesNote/From";

import { useParams } from "react-router";
import Settlements from "component/pages/settlement/Settlements";
import Invoice from "component/pages/invoice/Invoice";
import AnnualStatement from "component/pages/annualStatement/AnnualStatement";
import SalesConfirmations from "component/pages/salesConfirmation/SalesConfirmation";
import Contracts from "component/pages/contract/Contract";
import LandingNoteForm from "component/pages/landingNote/From";
import PurchaseOverview from "component/pages/purchaseOverview/PurchaseOverview";
import ReleasedPackagePage from "component/pages/releasePackage/ReleasePackage";
import PickListPage from "component/pages/pickList/PickList";
import PurchaseStatisticPage from "component/pages/purchaseStatistic/PurchaseStatistic";
import FreshSales from "component/pages/freshSales/FreshSales";
import FrozenSalesPage from "component/pages/frozenSales/FrozenSales";
import FrozenSalesWeeklyPage from "component/pages/frozenSalesWeekly/FrozenWeeklySales";
import SalesStatisticsPage from "component/pages/salesStatistic/SalesStatistics";
import OpenedStatisticsPage from "component/pages/openedStatistics/OpenedStatistics";
import StoreStatisticsPage from "component/pages/storeStatistics/StoreStatistics";
import AuctionedWeightPage from "component/pages/auctionedWeight/AuctionedWeight";
import { UserProfileSetting } from "component/pages/userProfileSetting/UserProfileSetting";
import ForgotSigningPasswordPage from "component/pages/administration/ForgotSigningPassword";
import UserListPage from "component/pages/administration/UserList";
import LandingNoteJournal from "component/pages/landingNoteJournal/LandingNoteJournal";
import LandingNoteJournalList from "component/pages/landingNoteJournalList/LandingNoteJournalList";
import UserInformationPage from "component/pages/administration/UserInformation";
import { useHomePageAccessStore, useUserStore } from "store";
import CompanyAdminUserInformationPage from "component/pages/administration/companyAdmin/UserInformation";
import { UserRole } from "interface/user";
import UserAgreementsList from "component/pages/administration/userAgreement/UserAgreementsList";
import SignatureForm from "../pages/signature/SignatureForm";
import NewUserForm from "component/pages/administration/NewUserForm";
import QuotaTransactionPage from "component/pages/quotaTransaction/QuotaTransaction";

const Pages: React.FC<{ currentPage: string }> = ({ currentPage }) => {
	let { path, id, action } = useParams();
	const { roles } = useUserStore();
	const checkMenuPageName = (page: string) => {
		return currentPage === page;
	};

	useEffect(() => {
		if (!path) {
			return;
		}
	}, []);

	const checkRole = (role: UserRole) => {
		if (!roles || roles.length === 0) {
			return false;
		}
		return roles.some((r) => r === role);
	};
	return (
		<div
			className="pages-content-shell"
			style={{
				//height: "100%",
				// height: "calc(100vh - 150px)",
				paddingRight: 30,
				paddingLeft: 25,
				// paddingBottom: 50,
			}}
		>
			{checkMenuPageName(PageTypePath.Home) && <HomePageItems />}

			{checkMenuPageName(PageTypePath.RegistrationList) && <RegistrationList />}
			{checkMenuPageName(PageTypePath.RegistrationForm) && <RegistrationForm />}

			{checkMenuPageName(PageTypePath.SalesNotesList) && <SalesNotesList />}
			{checkMenuPageName(PageTypePath.SalesNoteForm) && <SalesNoteForm />}

			{checkMenuPageName(PageTypePath.LandingNoteList) && <LandingNoteList />}
			{checkMenuPageName(PageTypePath.AccountingSettlement) && <Settlements />}
			{checkMenuPageName(PageTypePath.AccountingInvoice) && <Invoice />}
			{checkMenuPageName(PageTypePath.AccountingAnnualReport) && (
				<AnnualStatement />
			)}
			{checkMenuPageName(PageTypePath.SalesConfirmations) && (
				<SalesConfirmations />
			)}
			{checkMenuPageName(PageTypePath.SalesContract) && <Contracts />}
			{checkMenuPageName(PageTypePath.LandingNoteForm) && <LandingNoteForm />}

			{checkMenuPageName(PageTypePath.PurchaseOverview) && <PurchaseOverview />}
			{checkMenuPageName(PageTypePath.ReleasedPackages) && (
				<ReleasedPackagePage />
			)}

			{checkMenuPageName(PageTypePath.PickList) && <PickListPage />}

			{checkMenuPageName(PageTypePath.PurchaseStatistic) && (
				<PurchaseStatisticPage />
			)}

			{checkMenuPageName(PageTypePath.FreshSales) && <FreshSales />}
			{checkMenuPageName(PageTypePath.FrozenSales) && <FrozenSalesPage />}
			{checkMenuPageName(PageTypePath.FrozenSalesWeekly) && (
				<FrozenSalesWeeklyPage />
			)}
			{checkMenuPageName(PageTypePath.SalesStatistics) && (
				<SalesStatisticsPage />
			)}
			{checkMenuPageName(PageTypePath.OpenStatistics) && (
				<OpenedStatisticsPage />
			)}
			{checkMenuPageName(PageTypePath.StoreStatistics) && (
				<StoreStatisticsPage />
			)}
			{checkMenuPageName(PageTypePath.AuctionedWeight) && (
				<AuctionedWeightPage />
			)}
			{checkMenuPageName(PageTypePath.UserProfiles) && <UserProfileSetting />}
			{checkMenuPageName(PageTypePath.UserInformation) && (
				<>
					{checkRole(UserRole.Firmaadministrator) && (
						<CompanyAdminUserInformationPage />
					)}
					{checkRole(UserRole.Admin) && <UserInformationPage />}
				</>
			)}

			{checkMenuPageName(PageTypePath.ForgotSigningPassword) && (
				<ForgotSigningPasswordPage />
			)}
			{checkMenuPageName(PageTypePath.LandingNoteJournal) && (
				<LandingNoteJournal />
			)}
			{checkMenuPageName(PageTypePath.LandingNoteJournalList) && (
				<LandingNoteJournalList />
			)}

			{checkMenuPageName(PageTypePath.Users) && <UserListPage />}

			{checkMenuPageName(PageTypePath.NewUser) && <NewUserForm />}

			{checkMenuPageName(PageTypePath.NewAgreementUsers) && (
				<UserAgreementsList />
			)}

			{checkMenuPageName(PageTypePath.Signature) && <SignatureForm />}
			{checkMenuPageName(PageTypePath.QuotaTransactions) && (
				<QuotaTransactionPage />
			)}

			{!pageNotFound(currentPage) && <Error404 />}
		</div>
	);
};

export default Pages;
